import React from 'react'

import useEmail from '../hooks/useEmail'
import EmailLink from './EmailLink'
import { StaticImage } from 'gatsby-plugin-image'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import Logo from '../img/logo.inline.svg'

export default function Footer() {
  const { t } = useTranslation()

  const { email } = useEmail()

  return (
    <footer
      id="footer"
      className="bg-violet font-secondary text-sm text-gray-100"
    >
      <div className="mx-auto w-full px-8 py-20 lg:max-w-7xl">
        <Logo className="w-40 fill-white" />
        <p className="mt-8 text-gray-100 text-opacity-80">
          We believe in <strong>simple</strong>, <strong>creative</strong> &amp;{' '}
          <strong>flexible</strong> software
        </p>
        <div className="mt-4 grid h-20 w-72 grid-cols-1 grid-rows-1">
          <div className="col-start-1 row-start-1 flex flex-col">
            <address className="not-italic">
              <strong>{t('shared.headquarters')}:</strong>
              <br />
              Birsigstr. 102, 4054 Basel, Switzerland
            </address>
            <div>
              <abbr title="Email Address">
                <strong>Email:</strong>
              </abbr>{' '}
              <EmailLink email={email} />
              <br />
              <abbr title="Company Register Number">
                <strong>UID:</strong>
              </abbr>{' '}
              CHE-496.767.671
            </div>
          </div>
        </div>
        <p className="mt-5 text-gray-100 text-opacity-80">
          Copyright © {new Date().getFullYear()} {t('shared.rights')}
        </p>
      </div>
    </footer>
  )
}
